<template>
  <div class="row mb-4">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header px-2 py-2">
          <button v-if="canDelete" type="button" class="close ml-3" @click="deletePost()">
            <span aria-hidden="true">&times;</span>
          </button>

          <small class="float-right mt-1 text-muted">
            {{ post.created_at }}
          </small>

          <h5>
            <InitialAvatar
              :name="`${post.user.first_name} ${post.user.last_name}`"
            />
            {{ post.user.first_name }} {{ post.user.last_name }}
          </h5>
        </div>

        <div class="card-body">
          <p class="card-text post-message">
            {{ post.post }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InitialAvatar from "../InitialAvatar";

export default {
  props: {
    post: Object,
    canDelete: Boolean
  },
  components: {
    InitialAvatar: InitialAvatar,
  },
  data() {},
  methods: {
    deletePost() {
      this.$emit('delete', this.post)
    }
  },
};
</script>